module.exports = __webpack_public_path__ + "img/logo.ff3f2381.png";